import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SignupCompletedModule } from '../signup-completed/singup-completed.module';
import { SignupFinishComponent } from './signup-finish.component';

@NgModule({
    imports: [CommonModule, SignupCompletedModule],
    declarations: [SignupFinishComponent],
    exports: [SignupFinishComponent]
})
export class SignupFinishModule {}
